<script setup lang="ts">
  const { getComponentContent } = Cms.use()
  const { content } = await getComponentContent('IndexUrgencyBanner')

  const { flag } = FeatureFlags.use()
  const showIndexUrgencyBanner = computed(() => flag<boolean>('index-urgency-banner').value)

  const { isMobile } = Breakpoints.use()

  const text = computed(() =>
    isMobile.value ? content.value.ext.mobile_text : content.value.ext.text
  )
</script>

<template>
  <div
    v-if="showIndexUrgencyBanner"
    class="flex w-full items-center justify-center gap-x-1 bg-sky-800 px-2 py-1 text-center text-white"
  >
    <HpIcon v-if="content.ext.icon" :name="content.ext.icon" />
    <div v-html="text" class="urgency-text leading-tight" />
  </div>
</template>

<style scoped>
  .urgency-text :deep(strong) {
    @apply text-white;
  }
</style>
